import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=c6724fc6&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=c6724fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6724fc6",
  null
  
)

export default component.exports